import React from 'react';
import './articolo-canvas.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';

const ArticoloCanvas = ({title,author,date,text}) => {
  const navigate=useNavigate();
  return (
    <div className="canvas-container">
        <div className="canvas">
            <div className="author-date">
              <button className="back-btn" onClick={() => navigate(-1)}><FontAwesomeIcon icon={faChevronLeft} /> Indietro</button>
                <h3>{author} - {date}</h3>
            </div>
            <div className="article-title">
                <h2>{title}</h2>
            </div>
            <div className="article-text" dangerouslySetInnerHTML={{ __html: text }} />          
        </div>
    </div>
  )
}

export default ArticoloCanvas